import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Users";
import getToken from "app/api/getToken";
import { IUserResponse } from "app/api/types";

export const DEL_USER_PROFILE_REQUEST = "DEL_USER_PROFILE_REQUEST";
export const DEL_USER_PROFILE_SUCCESS = "DEL_USER_PROFILE_SUCCESS";
export const DEL_USER_PROFILE_FAIL = "DEL_USER_PROFILE_FAIL";

export const delUserProfile = (id: number) => (dispatch: any): any => {
  dispatch({ type: DEL_USER_PROFILE_REQUEST });

  const token = getToken();

  return api
    .delUserProfile(token, id)
    .then((response: AxiosResponse) => {
      const user: IUserResponse = get(response, "data.data", {});
      dispatch({ type: DEL_USER_PROFILE_SUCCESS, payload: user });

      return user;
    })
    .catch(err => {
      dispatch({
        type: DEL_USER_PROFILE_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
